import { useTranslation } from "react-i18next";
import { MultiRadioTable } from "../../../components/MultiRadioTable";

type Props = {
  form: any;
};

const Component = ({ form }: Props) => {
  const { t } = useTranslation();
  return (
    <MultiRadioTable
      form={form}
      label={t("concepts.label")}
      options={[
        { label: `${t("yes")}.`, value: "Sí." },
        { label: `${t("no")}.`, value: "No." }
      ]}
      questions={t("concepts.questions", { returnObjects: true }) as string[]}
      questionIds={["CPT_001", "CPT_002", "CPT_004", "CPT_003"]}  // It works!, but try to correct the order of the questions to be perfect matching with the options in the table
    />
  );
};

export default Component;
